import React from 'react';

//Hooks
import {useEffect, useCallback} from 'react';
import {useSelector, useDispatch} from "react-redux";
import {useTranslation} from "react-i18next";

//Actions
import {getPastReservations} from '../../../store/actions/reservations';

//Components
import {Container} from 'react-bootstrap'
import Icon from '../../../components/Icon/Icon';
import Loader from 'react-loader-spinner'

//Styles
import Styles from './History.module.scss';
import Reservation from '../../../components/Reservation/Reservation';

const History = () => {
    const pastBookings = useSelector(state => state.reservations.pastBookings);
    const pastBundles = useSelector(state => state.reservations.pastBundles);
    const loading = useSelector(state => state.reservations.pastLoading);
    const noMorePastBookings = useSelector(state => state.reservations.noMorePastBookings);

    const dispatch = useDispatch();
    const {t} = useTranslation('common');

    const handleLoadMore = useCallback(() => {
        if (loading || noMorePastBookings) {
            return;
        }
        dispatch(getPastReservations(pastBookings.length, 10, true));
    }, [loading, noMorePastBookings, pastBookings, dispatch]);

    const handleScroll = useCallback(e => {
        const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
        if (!bottom) {
            return;
        }

        handleLoadMore();
    }, [handleLoadMore]);

    useEffect(() => {
        document.getElementById('scrollContainer').addEventListener('scroll', handleScroll);
        return () => {
            document.getElementById('scrollContainer').removeEventListener('scroll', handleScroll)
        }
    }, [handleScroll]);

    if (!loading && pastBookings.length === 0 && pastBundles.length === 0) {
        return (
            <div className={Styles.container}>
                <Icon name='calendar' size={58} color='#B3BDC8'/>
                <p className={Styles.error}>{t('reservationsScreen.pastReservations.noHistoricalReservations')}</p>
            </div>
        )
    }

    return (
        <>
            <div className={Styles.container}>
                <Container className={'px-0'}>
                    {pastBookings.map((reservation, i) => (
                        <Reservation
                            key={`prod-${i}`}
                            reservation={reservation}
                            type='product'
                            past
                        />
                    ))}
                    {pastBundles.map((reservation, i) => (
                        <Reservation
                            key={`bundle-${i}`}
                            reservation={reservation}
                            type='bundle'
                            past
                        />
                    ))}
                </Container>
                {loading && (
                    <div className={Styles.infinityScroll}>
                        <Loader type="TailSpin" color="#000" height={25} width={25}/>
                    </div>
                )}
            </div>
        </>
    )
};

export default History